import { useMemo } from 'react';

let c = 0;

export default function useId(prefix = '') {
    return useMemo(() => {
        return `${prefix}${c++}`;
    }, []);
}
